import { REPORT_TYPE } from 'interface';

export const reportType = [
  { id: REPORT_TYPE.personal, value: 'Отчет по дому' },
  { id: REPORT_TYPE.common, value: 'Общепоселковый отчет' },
];
